'use client';

import type { ReactNode } from 'react';
import { Toaster } from 'sonner';
import { AuthedProviders } from '@/components/AuthedProviders';
import { AuthBootstrap } from '@/components/AuthBootstrap';
import { TelegramBackButtonSetup } from '@/components/TelegramBackButtonSetup';
import { AuthGate } from '@/components/AuthGate';
import { ScreenPage } from '@/components/ScreenPage';
import { GlobalSubscriptions } from '@/components/GlobalSubscriptions';
import { GlobalAchievementSheet } from '@/components/GlobalAchievementSheet';
import { AchievementClaimSheet } from '@/screens/AchievementsScreen/components/AchievementClaimSheet';
import { ChickenManager } from '@/components/ChickenManager';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <AuthedProviders>
      <TelegramBackButtonSetup />
      <AuthGate>
        <AuthBootstrap>

          <GlobalSubscriptions />
          <GlobalAchievementSheet />
          <AchievementClaimSheet />
          <ChickenManager />
          <ScreenPage>{children}</ScreenPage>
        </AuthBootstrap>
      </AuthGate>

      <Toaster position="top-center" theme="dark" richColors />
    </AuthedProviders>
  );
}
